
import React from 'react';

export const ValuePropositionSection: React.FC = () => {
  return (
    <section id="overview" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
            왜 지금 모아타운인가?
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            강남권 입지와 정비 시너지로 주거가치 재편
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="bg-white rounded-lg p-8 shadow-lg hover:shadow-xl transition-shadow">
            <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mb-6 mx-auto">
              <i className="ri-building-line text-2xl text-green-600"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-4 text-center">
              도시계획 트렌드
            </h3>
            <p className="text-gray-600 text-center leading-relaxed">
              강남구 일원동 지역의 체계적인 도시정비사업이 본격화되면서 
              모아타운 방식의 소규모 정비가 주목받고 있습니다.
            </p>
          </div>
          
          <div className="bg-white rounded-lg p-8 shadow-lg hover:shadow-xl transition-shadow">
            <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mb-6 mx-auto">
              <i className="ri-hammer-line text-2xl text-green-600"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-4 text-center">
              노후주거지 정비 필요성
            </h3>
            <p className="text-gray-600 text-center leading-relaxed">
              30년 이상 노후 단독주택의 안전성과 주거환경 개선이 
              시급한 상황에서 모아타운은 최적의 해결책입니다.
            </p>
          </div>
          
          <div className="bg-white rounded-lg p-8 shadow-lg hover:shadow-xl transition-shadow">
            <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mb-6 mx-auto">
              <i className="ri-road-map-line text-2xl text-green-600"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-4 text-center">
              지역 인프라 확충 예정
            </h3>
            <p className="text-gray-600 text-center leading-relaxed">
              대청역 접근성 개선, 생활편의시설 확충 등 
              지역 발전계획과 연계된 시너지 효과를 기대할 수 있습니다.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
